"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// apollo 订单状态码
var ORDER_STATUS = exports.ORDER_STATUS = {
  // 生成运单
  CREATE: 0,
  // 配送商接单
  ACCEPT: 10,
  // 分配配送员
  ASSIGN: 20,
  // 配送员到店
  ARRIVAL: 80,
  // 配送员送餐
  FETCH: 30,
  // 配送完成
  COMPLETE: 40,
  // 配送取消
  CANCEL: 60,
  // 配送异常
  EXCEPTION: 70,
  // 配送失败
  FAIL: 90
};


//////////////////
// WEBPACK FOOTER
// ./~/@ele/lpd-component/lib/components/order-dialog/src/constants/order.js
// module id = 174
// module chunks = 0